<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">회원리스트</div>
                    <member-list-component :memberType="'normal'"></member-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MemberListComponent from "@/components/member/MemberListComponent";
    export default {
        name: 'Member',
        components: {
            MemberListComponent
        },
        mixins: [ ],
        data() {
            return{

            }
        },
        mounted() {
        },
        computed: {
        },
        methods: {
        }
    }
</script>
